'use client'
// components/PreviewModeComponent.js
import {
  Alert,
  AlertTitle,
  AlertDescription,
  AlertIcon,
  Tooltip,
  Button,
} from '@chakra-ui/react'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { CloseIcon } from '@chakra-ui/icons'

const PreviewModeBanner = () => {
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()

  const handleDisableDraft = async () => {
    const response = await fetch('/api/disable-draft')
    setIsLoading(true)
    if (response.ok) {
      router.refresh()
    } else {
      setIsLoading(false)
      console.error('Failed to disable Preview Mode')
    }
  }

  return (
    <Alert
      status='warning'
      variant='solid'
      alignItems='center'
      justifyContent='space-between'
      textAlign='center'
      height='3.125rem'
      pos='fixed'
      bottom='0'
      zIndex='100'
    >
      <AlertTitle fontSize='lg' display='flex' alignItems='center'>
        <AlertIcon />
        Preview Mode
      </AlertTitle>
      <AlertDescription maxWidth='sm' display='flex' alignItems='center'>
        <Tooltip
          label='Click here to leave preview mode'
          placement='top'
          closeDelay={500}
        >
          <Button
            rightIcon={<CloseIcon />}
            colorScheme='gray'
            variant='ghost'
            isLoading={isLoading}
            loadingText='Disabling preview mode'
            onClick={handleDisableDraft}
            spinnerPlacement='end'
            color='white'
            _hover={{ backgroundColor: 'rgba(0, 0, 0, 0.24)' }}
          >
            Exit preview mode
          </Button>
        </Tooltip>
      </AlertDescription>
    </Alert>
  )
}

export default PreviewModeBanner
